// extracted by mini-css-extract-plugin
export var wrapper = "Hero-module--wrapper--3c7OQ";
export var image = "Hero-module--image--1nqef";